import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Signup from '@/components/Signup'
import Rooms from '@/components/Rooms'
import Room from '@/components/Room'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', name: 'Top', component: Top, meta: { isPublic: true } },
    { path: '/signup', name: 'Signup', component: Signup, meta: { isPublic: true } },
    { path: '/rooms', name: 'Rooms', component: Rooms },
    { path: '/rooms/:id', name: 'Room', component: Room },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.isPublic) && localStorage['id'] == null) {
    next({ path: '/', query: { redirect: to.fullPath }});
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js